module.exports = __webpack_public_path__ + "static/media/selected_boatramp_marker.9dac6adc.svg";